import { NgModule } from '@angular/core';
import { JoinMainComponent } from './pages/main';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { JoinInviteModule } from './invite/join-invite.module';

const PROVIDERS = [
  // ...services
];

@NgModule({
  declarations: [
    JoinMainComponent,
  ],
  exports: [
    JoinMainComponent,
  ],
  providers: [
    PROVIDERS
  ],
  imports: [    
    CommonModule,
    RouterModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    JoinInviteModule,
  ]
})
export class JoinModule { }
